/**
 * Traffic-light colour for a score, shared by the gauges and the question bars
 * so the two never drift apart.
 *
 * The thresholds are AMIL's: the bottom third of the range is red, the middle
 * third yellow, the top third green — 1.66 and 3.33 on the 1-5 answer scale,
 * 33.3 and 66.6 on a percentage.
 *
 * The prototype hardcoded #CC3F0C / #FFCC00 / #339933. These return the
 * application's severity tokens instead, so the colours match the rest of the
 * app and follow the active theme. Bind the result with `[style.*]`, never
 * `[attr.*]`: SVG presentation attributes do not resolve `var()`.
 */
export function scoreColor(value: number | null, max: number): string {
  if (value === null || isNaN(value)) {
    return 'var(--p-surface-300)';
  }

  const ratio = Math.min(1, Math.max(0, value / max));

  if (ratio <= 1 / 3) {
    return 'var(--p-red-500)';
  }

  if (ratio <= 2 / 3) {
    return 'var(--p-orange-500)';
  }

  return 'var(--p-green-500)';
}
